/* istanbul ignore file */
import StackTrace from 'stacktrace-js';
import StGPS from 'stacktrace-gps';
import { store } from '@common/store/store';
import { sDs } from '@common/sDs/sDs';
import { library } from '@common/library/library';
import { router } from "@common/router/router";

let newGps = new StGPS();
let lastActionsByComponent = {};
let lastRequestsByComponent = {};

const errorHandler = {
    namespaced: true,
    state: {
        enabled: true, // enable handle js errors
        enabledFromLocalhost: false, // enable handle js errors from localhost
        isRepeat: false, // repeater is working
        repeatComponentID: false,
        error: false, // error was thrown
        errorsSent: {},
        repeatAction: false,
        logLastActions: false,
        lastActions: {},
        lastRequests: {},
        repeaterCallstackIsShown: false,
        // please see CommonEnvironment.class performanceMonitorExcludeFileContains also
        // remove following sources from backtrace
        excludeFileNamesFromCallStack: [
            'webkit-masked-url',
            'syncfusion',
            'file:///',
            'chrome-extension',
            'safari-web-extension',
            'safari-extension',
            'modules/third-party', // angular code
            'modules/app-modules', // angular code
        ],
        // do not send error if message contains following strings:
        doNotSendWhenMessageContains: [
            '__webpack_modules__[moduleId].call',
            'identifier is a reserved word',
            'gCrWeb',
            'timeout of 0ms exceeded',
            'firstPagePromise',
            'googletag',
            'signOutTimeout',
            'signInTimeout',
            'googleapis',
            'failed after 5 retries',
            'className',
            'this.serverAffiliations[wfTabId] = resData.AFFILIATION',
            'Could not load "util"',
            '$rootScope:infdig',
            '$rootScope:inprog',
            'isFeatureBroken',
            'CSSStyleSheet.insertRule',
            'GSI_LOGGER'
        ], // please add which messages should not be sent
        jiraTicketInfo: false
    },
    getters: {},
    mutations: {
        addLastRequest: async function (state, payload) {
            let [cId, fArguments] = Object.values(payload);
            if (cId && fArguments) {
                if (typeof lastRequestsByComponent[cId] === 'undefined') lastRequestsByComponent[cId] = [];
                let tmpRequests = library.cloneObj(lastRequestsByComponent[cId]);
                if (!Array.isArray(tmpRequests)) {
                    tmpRequests = [];
                }
                let tmpFArguments = {};
                for (let i = 1; i < fArguments.length; i++) {
                    if (!(i === fArguments.length - 1 && typeof fArguments[i] === 'object' && fArguments[i] !== null && fArguments[i].sDsParams)) {
                        tmpFArguments[i] = fArguments[i];
                    }
                }
                if (tmpRequests.length >= 10) {
                    tmpRequests.splice(0, 1);
                }
                tmpRequests.push({
                    fName: fArguments[0],
                    fParams: tmpFArguments
                });
                lastRequestsByComponent[cId] = tmpRequests;
            }
        },
        addLastActions: async function (state, payload) {
            let [cId, fName, fArguments] = Object.values(payload);
            if (cId && fName && state.logLastActions) {
                if (typeof lastActionsByComponent[cId] === 'undefined') lastActionsByComponent[cId] = [];
                let tmpActions = library.cloneObj(lastActionsByComponent[cId]);
                let parsetFArguments = {};
                if (typeof fArguments === 'object') {
                    for (let tmpI in fArguments) {
                        try {
                            parsetFArguments[tmpI] = JSON.parse(JSON.stringify(fArguments[tmpI]));
                        } catch (e) {
                            if (typeof fArguments[tmpI] === 'object') {
                                if (typeof parsetFArguments[tmpI] === 'undefined') parsetFArguments[tmpI] = {};
                                for (let tmpj in fArguments[tmpI]) {
                                    try {
                                        parsetFArguments[tmpI][tmpj] = JSON.parse(JSON.stringify(fArguments[tmpI][tmpj]));
                                    } catch (e) {
                                        delete parsetFArguments[tmpI][tmpj];
                                    }
                                }
                            }
                        }
                    }
                }
                if (!Array.isArray(tmpActions)) {
                    tmpActions = [];
                }
                if (tmpActions.length >= 3) {
                    tmpActions.splice(0, 1);
                }
                tmpActions.push({
                    fName: fName,
                    fParams: parsetFArguments
                });
                lastActionsByComponent[cId] = tmpActions;
            }
        }
    },
    actions: {
        showRepeaterCallstack({ state }, payload) {
            if (state.repeaterCallstackIsShown) return;
            let [callStack] = Object.values(payload);
            state.repeaterCallstackIsShown = true;
            // eslint-disable-next-line no-console
            console.debug('Please set debug breakpoints for the following files and reload browser window:');
            for (let tmpI in callStack) {
                // eslint-disable-next-line no-console
                console.debug(callStack[tmpI]);
            }
        },
        log({ state }, payload) {
            let [logMessage, hideStack] = Object.values(payload);
            let processStack = () => {
                let doNotShowInStack = ['store.js', 'errorHandler.js'];
                try {
                    let stack = StackTrace.getSync({
                        filter: (stackFrame) => stackFrame.fileName.indexOf('vue.') === -1 && stackFrame.fileName.indexOf('chunk-vendors') === -1
                    });
                    for (let i in stack) {
                        if (i === 'length') continue;
                        newGps.pinpoint(stack[i]).then((tmpStack) => {
                            if (tmpStack.fileName.indexOf('components') !== -1 && !(new RegExp(doNotShowInStack.join("|")).test(tmpStack.fileName))) {
                                // eslint-disable-next-line no-console
                                console.log(tmpStack.fileName + ':' + tmpStack.lineNumber + '\n', logMessage);
                            }
                        });
                    }
                } catch (e) {
                    errorHandler.log(logMessage, true);
                }
            };
            if (typeof IS_JEST === 'undefined') {
                if (hideStack || !library.getBrowser().isChrome) {
                    // eslint-disable-next-line no-console
                    console.log(logMessage);
                } else {
                    processStack();
                }
            }
        },
        handle({ state }, payload) {
            let [errorMessage, options] = Object.values(payload);
            if (errorMessage === null) return;
            if (typeof location !== 'undefined' && location.href.indexOf('file:///') !== -1) return; // do not send errors from saved html
            let purposelyError = typeof errorMessage === 'string';
            let fromLocalhost = typeof FROM_LOCALHOST !== 'undefined' ? FROM_LOCALHOST : false;
            let removeLayoutControls = (objProp) => {
                for (let k in objProp.controls) {
                    if (k === 'length') continue;
                    if (typeof objProp.controls[k].itemsSource === 'undefined') continue;
                    delete objProp.controls[k].items;
                }
            };
            let removeLayoutContainerProps = (iCompState) => {
                for (let j in iCompState) {
                    if (j === 'length') continue;
                    if (typeof iCompState[j] !== 'object') continue;
                    delete iCompState[j].config;
                    removeLayoutControls(iCompState[j]);
                }
            };
            let sendToRepeater = () => {
                state.error = true;
                if (!(errorMessage instanceof Error) && !(errorMessage instanceof PromiseRejectionEvent)) errorMessage = new Error(errorMessage);
                if (errorMessage instanceof PromiseRejectionEvent) {
                    let stack = errorMessage.reason.stack;
                    let message = errorMessage.reason.message;
                    let status = errorMessage.reason && errorMessage.reason.response && errorMessage.reason.response.status ? errorMessage.reason.response.status : false;
                    let url = errorMessage.reason && errorMessage.reason.config && errorMessage.reason.config.url ? errorMessage.reason.config.url : false;
                    let postData = errorMessage.reason && errorMessage.reason.config && errorMessage.reason.config.data ? errorMessage.reason.config.data : false;
                    let config = errorMessage.reason && errorMessage.reason.config ? JSON.stringify(errorMessage.reason.config) : false;
                    let response = errorMessage.reason && errorMessage.reason.response ? JSON.stringify(errorMessage.reason.response) : false;
                    if (typeof message !== 'string') {
                        message = '';
                    }
                    if (status) {
                        message += '\nStatus:' + status;
                    }
                    if (url) {
                        message += '\nUrl:' + url;
                    }
                    if (postData) {
                        message += '\nPost Data:' + decodeURI(postData);
                    }
                    if (config) {
                        message += '\n\nConfig:' + config;
                    }
                    if (response) {
                        message += '\n\nResponse:' + response;
                    }
                    errorMessage = new Error(message);
                    errorMessage.stack = stack;
                }
                let sourceCache = {};
                sourceCache[location.href] = document.documentElement.outerHTML;
                sourceCache[location.origin + location.pathname] = document.documentElement.outerHTML;
                let message = typeof errorMessage === 'object' ? errorMessage.message : errorMessage;
                let hash = message.split('\n')[0];
                if (typeof state.errorsSent[hash] === 'undefined' || (options && options.allowMultiple)) {
                    state.errorsSent[hash] = true;
                } else {
                    return;
                }
                StackTrace.fromError(errorMessage,
                    {
                        // eslint-disable-next-line max-len
                        filter: (stackFrame) => {
                            let result = true;
                            if (stackFrame.fileName) {
                                // remove unnecessary files from call stack
                                for (let tmpI in state.excludeFileNamesFromCallStack) {
                                    if (stackFrame.fileName.indexOf(state.excludeFileNamesFromCallStack[tmpI]) !== -1) {
                                        result = false;
                                        break;
                                    }
                                }
                            }
                            return result;
                        },
                        sourceCache: sourceCache
                    }).then((stackTrace) => {
                    if (options && options.component) {
                        let tmpStackTrace = [];
                        for (let tmpI in stackTrace) {
                            if (stackTrace[tmpI] && stackTrace[tmpI].fileName) {
                                if (
                                    stackTrace[tmpI].fileName.indexOf('VMS/components') !== -1
                                    || stackTrace[tmpI].fileName.indexOf('app.js') !== -1
                                    || stackTrace[tmpI].fileName.indexOf('chunk-vendors.js') !== -1
                                    || stackTrace[tmpI].fileName.indexOf('webpack:///components') !== -1
                                    || stackTrace[tmpI].fileName.indexOf('node_modules/vue') !== -1
                                    || stackTrace[tmpI].fileName.indexOf('node_modules/@vue') !== -1
                                ) {
                                    tmpStackTrace.push(stackTrace[tmpI]);
                                }
                            }
                        }
                        stackTrace = tmpStackTrace;
                    }
                    if (!stackTrace.length || (typeof stackTrace[0].lineNumber === 'undefined' && typeof stackTrace[0].columnNumber === 'undefined')) return; // do not send errors without trace or if trace contains only 1 item (js error from console or plugin error)
                    if (stackTrace && stackTrace[0] && typeof stackTrace[0].fileName === 'string' && stackTrace[0].fileName.indexOf('custom/') !== -1) {
                        return; // do not send errors from custom js files
                    }
                    let stack = [];
                    let callStackForConsole = [];
                    let message = typeof errorMessage === 'object' ? errorMessage.message : errorMessage;
                    if (typeof message === 'string' && (message.toLowerCase().indexOf('network error') !== -1 || message.toLowerCase().indexOf('sourcemappingurl not found') !== -1)) {
                        library.showToast('Network Error, please try again later', { type: 'warning' });
                        return;
                    }
                    for (let tmpI in state.doNotSendWhenMessageContains) {
                        if (message.toLowerCase().indexOf(state.doNotSendWhenMessageContains[tmpI].toLowerCase()) !== -1) {
                            return;
                        }
                    }
                    if (typeof document !== 'undefined' && typeof document.forms[0] !== 'undefined') {
                        if (document.forms[0].classPath && document.forms[0].classPath.value) {
                            message = message + "\nClass Path: " + document.forms[0].classPath.value;
                        }
                        if (document.forms[0].class && document.forms[0].class.value) {
                            message = message + "\nClass: " + document.forms[0].class.value;
                        }
                        if (typeof window !== 'undefined' && window.name) {
                            message = message + "\nWindow Name: " + window.name;
                        }
                    }
                    for (let i in stackTrace) {
                        if (i === 'length') continue;
                        if (typeof stackTrace[i].fileName === 'undefined' || (typeof stackTrace[i].lineNumber === 'undefined' && typeof stackTrace[i].columnNumber === 'undefined')) continue;
                        let fileName = stackTrace[i].fileName.replace('webpack:///', '');
                        let functionName = '';
                        if (typeof stackTrace[i].functionName !== 'undefined') {
                            functionName = stackTrace[i].functionName.replace('VueComponent.', '');
                        }
                        let columnNumber = stackTrace[i].columnNumber;
                        let lineNumber = stackTrace[i].lineNumber;
                        stack.push(i + '. ' + functionName + '(' + fileName + ':' + lineNumber + ':' + columnNumber + ')');
                        callStackForConsole.push(fileName + ':' + lineNumber + ':' + columnNumber);
                    }
                    // let currentState = library.cloneObj(store.state);
                    if (!message) return;
                    if (stack.length) {
                        message = message + "\n\n" + stack.join("\n");
                    }
                    if (typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'signin' && ((message.indexOf('Loading chunk') !== -1 || message.indexOf('Loading CSS chunk') !== -1) && message.indexOf('CSS_CHUNK_LOAD_FAILED') === -1)) {
                        library.showToast('Sorry, there\'s a problem with the service.<br>Our developers have been notified.<br>Page will <a href="' + location.origin + location.pathname + '" style="color:white;">reload</a> in a 30 seconds', { timeout: 30 });
                        setTimeout(function () {
                            location.href = location.origin + location.pathname;
                        }, 30000); // NOSONAR
                        if (!library.getLocalStorage('stationReloadedAfterChunkError')) {
                            library.setLocalStorage('stationReloadedAfterChunkError', true);
                            return;
                        }
                        library.removeLocalStorage('stationReloadedAfterChunkError');
                    }
                    let currentState = '';
                    try {
                        let tmpComponent = options && options.component ? library.cloneObj(options.component) : false;
                        if (tmpComponent) {
                            let tmpCurrentState = {};
                            for (let i in tmpComponent) {
                                if (typeof tmpComponent.hasOwnProperty === 'function' && tmpComponent.hasOwnProperty(i)) {
                                    if (!(i.startsWith('vuex') || i.startsWith('_') || i.startsWith('layout') || i.startsWith('refs') || i.startsWith('sDs') || i.endsWith('Store')) && typeof tmpComponent[i] !== 'function') {
                                        tmpCurrentState[i] = library.cloneObj(tmpComponent[i]);
                                    }
                                }
                            }
                            currentState = {
                                "repeatComponentID": tmpComponent.cId,
                                "callStackForConsole": callStackForConsole,
                                "accordionMenu2": {
                                    "openedItem": 0
                                },
                                "componentList": {
                                    "selectedComponentId": tmpComponent.cId
                                },
                                "testDataList": {
                                    "controls": {
                                        "TEST_DATA_LIST": null
                                    }
                                },
                                "condensedFilter__components": {
                                    "controls": {
                                        "FILTER_LIST/FILTER_INPUT__all": [
                                            tmpComponent.cId
                                        ],
                                    }
                                },
                                "controlPanel_devDash": {
                                    "controls": {
                                        "POSITION_INDICATORS": false
                                    }
                                },
                                "componentPreview": {
                                    "previewEnabled": false
                                },
                                "componentDetails": {
                                    "lastComponentId": tmpComponent.cId
                                },
                                "tabList_cmpdetails": {
                                    "selectedTabIndex": 2,
                                    "lastTabIndex": 2,
                                    "loading": false
                                },
                                "componentTestData": {
                                    "isNew": true,
                                    "componentType": tmpComponent.cType,
                                    "controls": {
                                        "TEST_DATA_JSON": JSON.stringify(tmpCurrentState, null, 4),
                                        // "TEST_DATA_ACTION": JSON.stringify(tmpCurrentState, null, 4),
                                    }
                                }
                            };
                            currentState['lastActions'] = lastActionsByComponent[tmpComponent.cId];
                            currentState['lastRequests'] = lastRequestsByComponent[tmpComponent.cId];
                            for (let i in tmpComponent) {
                                if (typeof tmpComponent.hasOwnProperty === 'function' && tmpComponent.hasOwnProperty(i)) {
                                    if (i.endsWith('Store') && typeof tmpComponent[i] !== 'function' && i !== 'ddStore' && i !== 'localStore') {
                                        currentState[i] = library.cloneObj(tmpComponent[i]);
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        // do nothing and send without currentState
                    }
                    let jsErrorType = purposelyError ? 3 : 0;
                    let tmpMessageSubject = options && options.messageSubject ? options.messageSubject : false;
                    if (library.getCookie("isUnit")) {
                        library.showDialog(message.replaceAll('\n', '<br/>'), false, false, { title: 'JS Error' });
                    }
                    if (!library.objIsEmpty(message)) {
                        sDs.post('sds_handleJsError', message, currentState, jsErrorType, tmpMessageSubject);
                    }
                });
            };
            if (state.enabled && !state.isRepeat && (!fromLocalhost || state.enabledFromLocalhost)) {
                sendToRepeater();
            } else if (errorMessage) {
                // eslint-disable-next-line no-console
                console.error(errorMessage, { fromErrorHandler: true });
                if (fromLocalhost && typeof errorMessage === 'string' && errorMessage.indexOf('Browser freeze') !== -1) {
                    // show Browser freeze error in popup, so as not to miss
                    library.showDialog(errorMessage, false, false, { showAsAlert: true, title: 'Error' });
                }
            }
        }
    }
};

store.registerModule('errorHandler', errorHandler);

if (errorHandler.get('enabled') && typeof IS_JEST === 'undefined') {
    let oldThen = Promise.prototype.then;
    // eslint-disable-next-line no-extend-native
    Promise.prototype.cId = false;
    // eslint-disable-next-line no-extend-native
    Promise.prototype.then = function () {
        let _this = this;
        if (arguments.length === 1 && _this.cId) {
            return oldThen.apply(this, arguments).catch((tmpError) => {
                if (typeof _this !== 'undefined'
                    && typeof _this.component !== 'undefined'
                    && typeof _this.component.errorCaptured === 'function') {
                    _this.component.errorCaptured(tmpError);
                }
            });
        }
        return oldThen.apply(this, arguments);
    };
    let handleError = (error) => {
        errorHandler.handle(error);
    };
    window.onerror = function (msg, url, line, column, error) {
        handleError(error);
    };
    /* if (window?.console?.error) {
        try {
            let oldConsoleError = window.console.error;
            window.console.error = function () {
                if (arguments?.[1]?.fromErrorHandler !== true) {
                    handleError(arguments[0]);
                    oldConsoleError.apply(this, arguments);
                }
            };
        } catch (e) {
            // do nothing
        }
    } */
    window.addEventListener('unhandledrejection', function (error) {
        if (!errorHandler.get("error") && typeof (error.reason) !== "undefined") {
            if (error.reason.code === "ECONNABORTED") return;
            errorHandler.handle(error);
        }
    });
}

export { errorHandler };
